import { render, staticRenderFns } from "./LiveExample.vue?vue&type=template&id=eb24caa4&scoped=true&"
import script from "./LiveExample.vue?vue&type=script&lang=js&"
export * from "./LiveExample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb24caa4",
  null
  
)

export default component.exports